import { createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { makeRandomNumberString } from '@open-tender/utils';
const initialState = [];
const notificationsSlice = createSlice({
    name: ReducerType.Notifications,
    initialState,
    reducers: {
        showNotification: (state, action) => {
            return [
                ...state,
                { message: action.payload, id: makeRandomNumberString() }
            ];
        },
        hideNotification: (state, action) => {
            return state.filter(i => i.id !== action.payload);
        }
    }
});
export const { showNotification, hideNotification } = notificationsSlice.actions;
export const selectNotifications = (state) => state.notifications;
export const notificationsReducer = notificationsSlice.reducer;
